import { showModal } from '../../components/modals';
import { ConsentFormHandler } from './ConsentFormHandler';
export class EbueroConsentFormHandler extends ConsentFormHandler {
    displayConsentForm(originalSubmitId, formContainer) {
        this.displayNextConsentForm(originalSubmitId, formContainer) || this.displayGlobalConsentForm(originalSubmitId);
    }
    displayNextConsentForm(originalSubmitId, formContainer) {
        const nextForm = formContainer.nextElementSibling;
        if (nextForm === null || !nextForm.classList.contains('consent-form')) {
            return false;
        }
        nextForm.dataset.originalSubmitId = originalSubmitId;
        const consentPopup = nextForm.querySelector('.m-modal');
        if (consentPopup) {
            showModal(consentPopup);
        }
        const firstStep = nextForm.querySelector('.form-step');
        if (firstStep) {
            firstStep.classList.remove('js-hidden');
        }
        return true;
    }
}
